export default "__VITE_ASSET__CQhPwL4M__"